/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, LoadingOutlined, SubnodeOutlined } from '@ant-design/icons';

// Misc imports
import { NLP_PIPELINE_STATUSES } from '../../constants/main';

const NlpPipelineStatusTag = (props) => {
  const { pipelineStatus, ...restProps } = props;
  const { t } = useTranslation();

  const getTagIconAndColorProps = () => {
    switch (pipelineStatus) {
      case NLP_PIPELINE_STATUSES.READY:
        return {
          icon: <CheckCircleOutlined />,
          color: 'success'
        };

      case NLP_PIPELINE_STATUSES.FAILED:
        return {
          icon: <CloseCircleOutlined />,
          color: 'error'
        };

      case NLP_PIPELINE_STATUSES.TRAINING:
      case NLP_PIPELINE_STATUSES.SYNCING:
        return {
          icon: <LoadingOutlined spin />,
          color: 'processing'
        };

      case NLP_PIPELINE_STATUSES.OUTDATED:
        return {
          icon: <ExclamationCircleOutlined />,
          color: 'warning'
        };

      case NLP_PIPELINE_STATUSES.CREATED:
        return {
          icon: <SubnodeOutlined />,
          color: 'processing'
        };

      case NLP_PIPELINE_STATUSES.INITIALIZING:
        return {
          icon: <LoadingOutlined />,
          color: 'processing'
        };

      default:
        return null;
    }
  };

  return (
    <Tag {...getTagIconAndColorProps()} {...restProps}>
      {t(pipelineStatus, { context: 'nlp pipeline status' })}
    </Tag>
  );
};

NlpPipelineStatusTag.propTypes = {
  pipelineStatus: PropTypes.string
};

export default NlpPipelineStatusTag;
